export default "__VITE_ASSET__db33fa36__"